import { Link } from "react-router-dom";

export function Logo({ to = "/earn" }: { to?: string }) {
  return (
    <Link className="logo" to={to} aria-label="Bucks home">
      <span className="logo-mark" aria-hidden="true">B</span>
      <span>BUCKS</span>
    </Link>
  );
}
